import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '../../Icons/CloseBold';
import { IconSize } from '../../Icons/IconWrap';
import { EmoteStreamType } from '../redux/types';
import { streamTypeToSearchType } from '../constants';
import s from './SearchHeader.scss';
var SearchHeader = function (_a) {
    var activeStreamType = _a.activeStreamType, onSwitchStream = _a.onSwitchStream, onClose = _a.onClose;
    var t = useTranslation().t;
    var _b = useState(''), searchQuery = _b[0], setSearchQuery = _b[1];
    var searchType = streamTypeToSearchType[activeStreamType];
    var handleKeyDown = function (e) {
        if (e.key === 'Escape') {
            onClose();
        }
        if (e.key === 'Enter') {
            e.target.blur();
            onSwitchStream({
                streamType: EmoteStreamType.SEARCH,
                searchQuery: searchQuery,
                searchType: searchType,
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { "aria-label": searchType !== 'community'
                ? t('emoteselector.search.users')
                : t('emoteselector.search'), autoFocus: true, className: s['search-input'], type: "text", placeholder: " " + (searchType !== 'community'
                ? t('emoteselector.search.users')
                : t('emoteselector.search')), onChange: function (e) {
                setSearchQuery(e.target.value);
            }, onKeyDown: handleKeyDown }),
        React.createElement("button", { onClick: onClose, className: s['close-button'], "aria-label": t('emoteselector.search.button.a11y.close') },
            React.createElement(CloseIcon, { size: IconSize.SMALL, className: s['close-icon'] }))));
};
SearchHeader.displayName = 'SearchHeader';
export default SearchHeader;
//# sourceMappingURL=SearchHeader.js.map